import Sponsor from './sponsor'

export default Sponsor